import React from 'react';
import { useHistory, useParams } from 'react-router';
import Title from 'lib/src/components/typography/Title';
import Form from '@components/form/Form';
import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import TextArea from '@components/form/TextArea';
import Select from '@components/form/Select';
import { Organisation } from 'src/types/shared/Organisation';
import useEditOrganisationForm from './hooks/useEditOrganisationForm';
import { organisationSizeValues, organisationTypeValues } from 'lib/src/types/shared/Organisations';

interface Props {
    organisation: Organisation;
}

interface Params {
    id: string;
}

interface DropdownOption {
    value: number;
    label: string;
}

const EditOrganisationForm = ({ organisation }: Props) => {
    const { id } = useParams<Params>();
    const history = useHistory();
    const redirect = () => history.push(`/assessments/submissions/submission/${id}`);

    const {
        data: { ktnEntrySummary, organisationSize, organisationType },
        handleChange,
        handleSubmit,
        isPatching,
    } = useEditOrganisationForm(organisation, redirect);

    const typeDropdownOptions: DropdownOption[] = Object.keys(organisationTypeValues).map(value => {
        return {
            value: +value,
            //@ts-ignore
            label: organisationTypeValues[+value],
        };
    });

    const sizeDropdownOptions: DropdownOption[] = Object.keys(organisationSizeValues).map(value => {
        return {
            value: +value,
            //@ts-ignore
            label: organisationSizeValues[+value],
        };
    });

    return (
        <Form onSubmit={handleSubmit} isPosting={isPatching} onCancel={redirect}>
            <ContentBlock>
                <ContentRow>
                    <Title>Enter details</Title>
                </ContentRow>

                <ContentRow>
                    <ContentItem>
                        <Select
                            name="organisationType"
                            value={organisationType}
                            onChange={handleChange}
                            label="Organization type"
                            options={typeDropdownOptions}
                        />
                    </ContentItem>
                    <ContentItem>
                        <Select
                            name="organisationSize"
                            value={organisationSize}
                            onChange={handleChange}
                            label="Organization size"
                            options={sizeDropdownOptions}
                        />
                    </ContentItem>
                </ContentRow>

                <ContentRow>
                    <ContentItem>
                        <TextArea
                            name="ktnEntrySummary"
                            value={ktnEntrySummary}
                            onChange={handleChange}
                            style={{ width: '100%', marginTop: 8 }}
                            label="Entry Summary"
                            minRows={5}
                            required
                        />
                    </ContentItem>
                </ContentRow>
            </ContentBlock>
        </Form>
    );
};

export default EditOrganisationForm;
